export const gerarHashForString = (texto) => {
    let hash = 0;
    if (texto.length == 0) return hash;
    for (let i = 0; i < texto.length; i++) {
        let char = texto.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash;
}